"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _InformationChange = require("@/api/member/InformationChange");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InformationChange',
  data: function data() {
    return {
      regionalInformation: false,
      userOptionData: [],
      page: 1,
      limit: 10,
      total: 0,
      memberId: ''
    };
  },
  methods: {
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.queryMemberUpdateLogsApi();
    },
    // 当前分页
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.queryMemberUpdateLogsApi();
    },
    open: function open(id) {
      this.regionalInformation = true;
      this.memberId = id;
      this.queryMemberUpdateLogsApi();
    },
    regionClose: function regionClose() {
      this.regionalInformation = false;
    },
    queryMemberUpdateLogsApi: function () {
      var _queryMemberUpdateLogsApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                memberId: this.memberId,
                page: this.page,
                size: this.limit
              };
              _context.n = 1;
              return (0, _InformationChange.listBalance)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                console.log(res);
                this.total = res.data.dataPage.total;
                this.userOptionData = res.data.dataPage.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function queryMemberUpdateLogsApi() {
        return _queryMemberUpdateLogsApi.apply(this, arguments);
      }
      return queryMemberUpdateLogsApi;
    }()
  }
};